/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import type { ReactNode } from 'react';
import React, { Children, forwardRef } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  centerPadding?: number;
  children: ReactNode;
  className?: string;
  style?: CSSRuleList;
  currentIndex: number;
  fadeUnseenItems?: boolean;
  hasControls: boolean;
  isSwiping?: boolean;
  itemPercentSize: number;
  itemsAreaClassName?: string;
  onSwipeEnd?: (event: TouchEvent) => void;
  onSwipeMove?: (event: TouchEvent) => void;
  onSwipeStart?: (event: TouchEvent) => void;
  position: number;
  spacerWidth?: number;
};
export const SliderHandlerItems = forwardRef<Props, HTMLDivElement>(
  function SliderHandlerItems(props, ref) {
    const {
      centerPadding = 0,
      children,
      className = '',
      style,
      currentIndex,
      fadeUnseenItems,
      hasControls,
      isSwiping,
      itemPercentSize,
      itemsAreaClassName,
      onSwipeEnd,
      onSwipeMove,
      onSwipeStart,
      position,
      spacerWidth = 0,
    } = props;
    return (
      <div
        className={classnames('overflow-hidden', className)}
        ref={ref}
        tabIndex={hasControls ? 0 : -1}
        style={style}
      >
        <div
          className={classnames(
            itemsAreaClassName,
            'tap-highlight-color-transparent flex h-full will-change-transform',
            {
              'transition-transform duration-250 ease-in': !isSwiping,
            },
          )}
          style={{
            transform: `translate(${position}%, 0)`,
            ...(centerPadding
              ? {
                  padding: `0 ${centerPadding * 100}%`,
                }
              : {}),
          }}
          onTouchStart={onSwipeStart}
          onTouchMove={onSwipeMove}
          onTouchEnd={onSwipeEnd}
        >
          {Children.map(children, (child, idx) => {
            const isCurrentItem = currentIndex === idx;
            return (
              <div
                aria-hidden={child.props.ariaHidden}
                className={classnames('max-w-full will-change-transform', `px-${spacerWidth}`, {
                  'transition-opacity duration-250 ease-in': !isSwiping,
                })}
                key={idx}
                style={{
                  minWidth: `${itemPercentSize}%`,
                  maxWidth: `${itemPercentSize}%`,
                  opacity: isCurrentItem || !fadeUnseenItems ? 1 : 0.3,
                }}
                tabIndex={child.props.tabIndex}
              >
                {child}
              </div>
            );
          })}
        </div>
      </div>
    );
  },
);
